// ============================================================================
// UKRAINIAN TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// Духовні скарби зі Слова

export const bibleTreasures = [
  {
    type: "perle_sagesse",
    content: "Божественна мудрість - не абстрактна теорія, а конкретне життя, що виявляється в наших щоденних виборах",
    reference: "Приповісті 3:13-18",
    category: "мудрість",
    strongNumbers: {
      "мудрість": "H2451", // חָכְמָה (chokmah) = практична мудрість
      "розум": "H8394" // תְּבוּנָה (tebunah) = розрізнення
    },
    reflection: "Як я можу застосувати божественну мудрість у своїх рішеннях сьогодні?"
  },
  {
    type: "tresor_divine",
    content: "Божа любов не залежить від наших заслуг, це вічний дар, що виходить з Його власної природи",
    reference: "Римлян 8:38-39",
    category: "любов",
    strongNumbers: {
      "любов": "G26", // ἀγάπη (agape) = безумовна любов
      "відлучити": "G5563" // χωρίζω (chorizo) = розділити
    },
    reflection: "Ніщо не може відлучити нас від любові Божої, виявленої в Христі"
  },
  {
    type: "lumiere_vie",
    content: "Ісус - світло, що освітлює не лише наш шлях, а й наше внутрішнє буття",
    reference: "Івана 8:12",
    category: "ідентичність",
    strongNumbers: {
      "світло": "G5457", // φῶς (phos) = світло
      "життя": "G2222" // ζωή (zoe) = рясне життя
    },
    reflection: "Як я дозволяю світлу Христа освітлювати мої області темряви?"
  },
  {
    type: "force_divine",
    content: "Наша сила виходить не з нас самих, а від Того, хто живе в нас",
    reference: "Ефесян 3:16-17",
    category: "сила",
    strongNumbers: {
      "зміцнитися": "G2901", // κραταιόω (krataioo) = зміцнювати
      "сила": "G1411" // δύναμις (dynamis) = божественна сила
    },
    reflection: "У моменти слабості чи довіряю я силі Божій?"
  },
  {
    type: "paix_profonde",
    content: "Божий мир не залежить від зовнішніх обставин, а від Його постійної присутності в наших серцях",
    reference: "Филип'ян 4:6-7",
    category: "безтурботність",
    strongNumbers: {
      "мир": "G1515", // εἰρήνη (eirene) = повний мир
      "охоронятиме": "G5432" // φρουρέω (phroureo) = охороняти як фортеця
    },
    reflection: "Як я плекаю мир Божий, що перевищує всякий розум?"
  },
  {
    type: "esperance_vivante",
    content: "Наша надія - не невизначене бажання, а міцний якір, заснований на вірних обітницях Бога",
    reference: "Євреїв 6:19",
    category: "надія",
    strongNumbers: {
      "надія": "G1680", // ἐλπίς (elpis) = впевнена надія
      "якір": "G45" // ἄγκυρα (ankyra) = якір душі
    },
    reflection: "На яких обітницях Бога я закріплюю свою надію сьогодні?"
  },
  {
    type: "transformation",
    content: "Духовне перетворення - безперервний процес, у якому ми щодня стаємо більш подібними до образу Христа",
    reference: "2 Коринфян 3:18",
    category: "зростання",
    strongNumbers: {
      "перетворюємося": "G3339", // μεταμορφόω (metamorphoo) = повністю перетворювати
      "слава": "G1391" // δόξα (doxa) = божественна слава
    },
    reflection: "Які області мого життя потребують перетворення сьогодні?"
  }
];

export default bibleTreasures;
